import { debounce, fork, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ME_REQUEST,
  FETCH_THIRD_PARTY_SSO_URL_REQUEST,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  RESET_PASSWORD_EMAIL_REQUEST,
  UPDATE_CURRENT_USER_PREFERENCES_REQUEST,
} from '../constants';
import { fetchMeSaga } from './fetchMeSaga';
import { fetchThirdPartyUrlSaga } from './fetchThirdPartyUrlSaga';
import { loginSaga } from './loginSaga';
import { logoutSaga } from './logoutSaga';
import { resetPasswordEmailSaga } from './resetPasswordEmailSaga';
import { updateCurrentUserPreferencesSaga } from './updateCurrentUserPreferencesSaga';
import { sessionCheckSaga } from './sessionCheckSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  yield takeLatest(FETCH_ME_REQUEST, fetchMeSaga);
  yield takeLatest(LOGOUT_REQUEST, logoutSaga);
  yield takeLatest(RESET_PASSWORD_EMAIL_REQUEST, resetPasswordEmailSaga);
  yield takeLatest(FETCH_THIRD_PARTY_SSO_URL_REQUEST, fetchThirdPartyUrlSaga);
  yield debounce(
    400,
    UPDATE_CURRENT_USER_PREFERENCES_REQUEST,
    updateCurrentUserPreferencesSaga
  );

  // Start the session check saga to verify user session every 5 minutes of inactivity
  yield fork(sessionCheckSaga);
}
